// extracted by mini-css-extract-plugin
module.exports = {"container":"dae1qhmUgSUypPu0rhjC_","visible":"_3AusLevryEbiAc5WdOcBFK","cancelBtn":"_179lw23f0RN7QC5S4QsIKL","icon":"t-ylsZTvbXCra0Fa3esAW","saveBtn":"_1h69nieotexdAbcADIZkU1"};